import { useState, useEffect } from 'react';
import { ChevronUp, X } from 'lucide-react';
import { NAV_LINKS } from '../../utils/constants';
import { scrollToSection } from '../../utils/scrollToSection';

const SmartNavigator = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
      const sections = ['home', 'capabilities', 'work', 'process', 'team', 'about', 'contact'];
      for (const section of [...sections].reverse()) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const handleNavigation = (href) => {
    setIsExpanded(false);
    if (href.startsWith('#')) {
      if (!scrollToSection(href)) window.location.href = `/${href}`;
    } else if (href.startsWith('/')) {
      window.location.href = href;
    }
  };
  
  if (!isVisible) return null;
  
  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button 
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center justify-center w-11 h-11 rounded-full transition-all duration-300"
        style={{
          background: 'var(--gradient-accent)',
          boxShadow: '0 0 20px rgba(209, 0, 163, 0.3)',
        }}
      >
        <ChevronUp 
          className="w-5 h-5 text-white transition-transform duration-300"
          style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
        />
      </button>
      
      <div
        className="absolute bottom-14 right-0 rounded-xl overflow-hidden transition-all duration-300 origin-bottom-right"
        style={{
          background: 'var(--bg-card)',
          border: '1px solid var(--border-subtle)',
          boxShadow: 'var(--shadow-lg)',
          opacity: isExpanded ? 1 : 0,
          transform: isExpanded ? 'scale(1)' : 'scale(0.9)',
          pointerEvents: isExpanded ? 'auto' : 'none',
          width: '240px',
        }}
      >
        <div className="p-4">
          <div className="flex justify-between items-center mb-3">
            <span className="text-mono text-xs" style={{ color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Navigate
            </span>
            <button onClick={() => setIsExpanded(false)}>
              <X className="w-3.5 h-3.5" style={{ color: 'var(--text-muted)' }} />
            </button>
          </div>
          
          <div 
            className="mb-4 px-3 py-2 rounded-lg text-xs"
            style={{ background: 'var(--accent-glow)', color: 'var(--accent-light)' }}
          >
            Viewing: <span className="font-medium capitalize">{activeSection}</span>
          </div>
          
          <div className="space-y-0.5">
            {NAV_LINKS.map((link, index) => (
              <button
                key={index}
                onClick={() => handleNavigation(link.href)}
                className="w-full text-left px-3 py-2 rounded-lg text-sm transition-colors duration-200"
                style={{
                  background: activeSection === link.id ? 'var(--accent-glow)' : 'transparent',
                  color: activeSection === link.id ? 'var(--accent-light)' : 'var(--text-tertiary)',
                }}
              >
                {link.name}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartNavigator;
